'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ConfirmationContext = /*#__PURE__*/React__default["default"].createContext(null);
const useConfirmation = () => {
  const context = React.useContext(ConfirmationContext);
  if (!context) {
    throw new Error('No context provided for Confirmation provider');
  }
  return context;
};
const ConfirmationProviderBase = _ref => {
  let {
    children,
    value: {
      claimEligibilityInfo,
      claimType
    }
  } = _ref;
  const {
    email
  } = claimEligibilityInfo;
  const {
    claimsConfirmationDescription,
    claimsConfirmationDescriptionWrongItem,
    claimsConfirmationDescriptionItemMissing,
    claimsConfirmationDescriptionItemDamaged,
    claimsConfirmationDescriptionPackageMissing
  } = nthHookTranslations.useTranslations();
  const claimTypeToDescriptionMapping = {
    ItemDamaged: claimsConfirmationDescriptionItemDamaged ?? '',
    ItemMissing: claimsConfirmationDescriptionItemMissing ?? '',
    PackageMissing: claimsConfirmationDescriptionPackageMissing ?? '',
    WrongItem: claimsConfirmationDescriptionWrongItem ?? ''
  };
  // Many retailers have claimsConfirmationDescription defined. Support for a claimType-based
  // claimTypeDescription was added later. Prefer the claimType-based description if it exists.
  const description = claimTypeToDescriptionMapping[claimType] || claimsConfirmationDescription || '';
  return /*#__PURE__*/React__default["default"].createElement(ConfirmationContext.Provider, {
    value: {
      email,
      description
    }
  }, children);
};
const ConfirmationProvider = nthHookTranslations.withTranslationsProvider(ConfirmationProviderBase, {
  translationKeys: ['claimsConfirmationDescription', 'claimsConfirmationDescriptionWrongItem', 'claimsConfirmationDescriptionItemMissing', 'claimsConfirmationDescriptionItemDamaged', 'claimsConfirmationDescriptionPackageMissing']
});

exports.ConfirmationContext = ConfirmationContext;
exports.ConfirmationProvider = ConfirmationProvider;
exports.useConfirmation = useConfirmation;
